import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import logo from '../asset/img/logo.png'
import '../page/Home.css'

function HomeMain({ activeNav, setActiveNav }) {
  const [searchQuery, setSearchQuery] = useState('');
  const [activeTab, setActiveTab] = useState('Ongoing');
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  return (
    <>
      <main className="main-content">
        <header className="top-header">
          <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
            <Link className="logo">
              <img src={logo} alt='' />
              <span>MMao</span>
            </Link>
            <div className="search-box">
              <i class="ri-search-line"></i>
              <input
                type="text"
                placeholder="Search courses, resources..."
                value={searchQuery}
                maxLength={45}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>

          <div className="header-actions">
            <button className="icon-btn profilebtn" onClick={() => {
              document.querySelector('.blurdiv').style.display='flex';
              document.querySelector('.right-sidebar').style.right=0;
            }}>
              <i class="ri-user-3-fill"></i>
            </button>
          </div>
        </header>
        <div className="page-title-row">
          <h1 className="page-title">{activeNav}</h1>
          <div className="filter-tabs">
            {['Ongoing', 'Favorite', 'Complete'].map((tab) => (
              <button
                key={tab}
                className={`filter-tab ${activeTab === tab ? 'active' : ''}`}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        { }
        <div className="courses-grid">
          {/* Banner Card - UI/UX Design */}
          <Link to={'/course/webdev1shn'} className="banner-card">
            <div className="banner-content">
              <span className="badge-pill">Coding</span>
              <h2 className="banner-title">ႁဵၼ်းတႅမ်ႈၶူတ်ႉ Web development 1</h2>
              <p className="banner-desc">ႁဵၼ်းသွၼ်တႅမ်ႈၶူတ်ႉၶူင်သၢင်ႈဝႅပ်ႉသၢႆႉတႃႇၽူႈတီႈဢၼ်ဢမ်ႇပႆႇမေႃသင်တႄႇပိုၼ်ႉၶၢမ်ႇတေႃႇထိုင်ၸၼ်ႉ frontend</p>
              <div className="banner-meta">
                <span>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path></svg>
                  30 Lessons
                </span>
                <span>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                  8h 9m 25s
                </span>
              </div>
            </div>
            <div className="banner-illustration">👨🏻‍💻</div>
          </Link>

          {/* Lower Side-by-Side Cards */}
          <div className="lower-cards-row">
            {/* Photography Card */}
            <Link to={'/course/webdev1shn'} className="small-card">
              <div>
                <div className="small-card-header">
                  <div className="card-icon-box photo-bg">👨🏻‍💻</div>
                  <span className='card-label'>Online/Offline</span>
                </div>
                <h3 className="small-card-title">ႁဵၼ်းတႅမ်ႈၶူတ်ႉ Web development 1</h3>
                <p className="small-card-desc">ႁဵၼ်းသွၼ်တႅမ်ႈၶူတ်ႉၶူင်သၢင်ႈဝႅပ်ႉသၢႆႉတႃႇၽူႈတီႈဢၼ်ဢမ်ႇပႆႇမေႃသင်တႄႇပိုၼ်ႉၶၢမ်ႇတေႃႇထိုင်ၸၼ်ႉ frontend</p>
              </div>
              <div className="small-card-footer">
                <span>30 Lessons</span>
                <span>8h 9m 25s</span>
              </div>
            </Link>
          </div>
        </div>
      </main>
      <nav className="bottom-nav-menu">
        {[
          { name: 'Home', icon: 'ri-home-3-fill' },
          { name: 'My courses', icon: 'ri-folder-video-fill' },
          { name: 'Documents', icon: 'ri-article-fill' },
          { name: 'Reviews', icon: 'ri-chat-ai-4-fill' },
          { name: 'Profile', icon: 'ri-user-3-fill' }
        ].map((item) => (
          <button
            key={item.name}
            className={`bottom-nav-item ${activeNav === item.name ? 'active' : ''}`}
            onClick={() => setActiveNav(item.name)}
          >
            <i class={item.icon}></i>
            <span>{item.name}</span>
          </button>
        ))}
      </nav>
    </>
  )
}

export default HomeMain